/* eslint-disable react/forbid-prop-types */
import React, { useMemo, useContext } from 'react';
import { InstrumentationContext } from './instrumentation-context';
import { IScenarioContext } from './types';

export const ScenarioContext = React.createContext<IScenarioContext | undefined>(undefined);

type Props = {
  children: React.ReactNode | React.ReactNode[];
  name: string;
};

export const Scenario = (props: Props) => {
  const instrumentation = useContext(InstrumentationContext);
  const context = useContext(ScenarioContext);

  const scenarioInstance = useMemo(() => {
    if (props.name) {
      if (context && context.value === props.name) {
        return context;
      } else if (instrumentation && instrumentation.createScenario) {
        return instrumentation.createScenario({
          scenarioName: props.name,
          parentScenario: context,
        });
      }
    }
    return undefined;
  }, [context, instrumentation, props.name]);

  return (
    <ScenarioContext.Provider value={scenarioInstance}>
      {props.children}
    </ScenarioContext.Provider>
  );
};
